import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {ChecklistsService} from '../../../common/services/checklists.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Localization} from '../../../common/enums/localization';
import {ChecklistNode} from './model/checklist-node';
import {filter, finalize, flatMap, take, tap} from 'rxjs/operators';
import {
  AppDeleteConfirmModalComponent
} from '../../../common/ui-components/app-delete-confirm-modal/app-delete-confirm-modal.component';
import {TreeNode} from './model/tree-node';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import {forkJoin} from 'rxjs';
import {
  AddCustomCheckpointModalComponent
} from '../components/add-custom-checkpoint-modal/add-custom-checkpoint-modal.component';
import {AddCustomCheckpointRequest} from './model/add-custom-checkpoint-request';
import {EditNodeModalComponent} from '../components/edit-node-modal/edit-node-modal.component';
import {TranslateService} from '@ngx-translate/core';
import {AddCheckpointType, TemplateChecklistNodeType} from '../../../common/enums/enums';
import {RenameChecklistModal} from '../components/rename-checklist-modal/rename-checklist-modal.component';
import {EditChecklistType} from '../../../common/enums/editChecklistTypeEnum';
import {CopyChecklistModalComponent} from '../components/copy-checklist-modal/copy-checklist-modal.component';
import {AddUpdateNodeModalComponent} from '../components/add-update-node-modal/add-update-node-modal.component';
import {
  SelectCheckpointCreationMethodModal
} from '../components/select-checkpoint-creation-method-modal/select-checkpoint-creation-method-modal.component';
import {
  AddUpdateCheckpointModalComponent
} from '../components/add-update-checkpoint-modal/add-update-checkpoint-modal.component';
import {IdAndLabel} from '../../../../modules/common/model/id-and-label';
import {ChecklistNodeCheckpoint} from './model/checklist-node-checkpoint';
import {TemplateCheckpoint} from '../../../../modules/common/model/template-checkpoint';
import {AddCheckpointDialogResult} from '../../../../modules/common/model/AddCheckpointDialogResult.model';
import {ConfirmationDialogModel, ConfirmDialogType, DialogService} from '@npm.chapps.com/chapps.common.angular.library';
import {SessionStorageService} from '../../../../modules/common/services/session-storage.service';
import {DOCUMENT} from '@angular/common';
import {
  DuplicateMultipleTimesData,
  DuplicateMultipleTimesModalComponent
} from "../components/duplicate-multiple-times-modal/duplicate-multiple-times-modal.component";
import {MDBModalService} from "ng-uikit-pro-standard";
import {
  SelectExistingCheckpointData,
  SelectExistingCheckpointModalComponent
} from "../components/select-existing-checkpoint-modal/select-existing-checkpoint-modal.component";
import {
  ChangeChecklistTypeModal
} from "../components/change-checklist-type-modal/change-checklist-type-modal.component";
import {ITreeNode} from '@ali-hm/angular-tree-component/lib/defs/api';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';

function isChildNodeOf(nodes: ChecklistNode[], id: number) {
  return nodes.some(childNode => childNode.id === id || isChildNodeOf(childNode.childNodes, id));
}

@Component({
  selector: 'app-checklist',
  templateUrl: './checklist.component.html',
  styleUrls: ['./checklist.component.scss'],
})
export class ChecklistComponent implements OnInit {

  @ViewChild('deleteNodeModal') deleteNodeModal: AppDeleteConfirmModalComponent;
  @ViewChild(EditNodeModalComponent) editNodeModal: EditNodeModalComponent;
  // @ViewChild(AddNodeOrCheckpointModalComponent) addModal: AddNodeOrCheckpointModalComponent;
  @ViewChild(AddCustomCheckpointModalComponent) addCustomCheckpointModal: AddCustomCheckpointModalComponent;
  @ViewChild(RenameChecklistModal) updateChecklistModal: RenameChecklistModal;
  @ViewChild('tree') tree;
  @ViewChild(CopyChecklistModalComponent) copyChecklistModal: CopyChecklistModalComponent;
  @ViewChild(AddUpdateNodeModalComponent) addUpdateNodeModal: AddUpdateNodeModalComponent;
  @ViewChild(SelectCheckpointCreationMethodModal) addCheckpointOptionsModal: SelectCheckpointCreationMethodModal;
  @ViewChild(AddUpdateCheckpointModalComponent) addUpdateCheckpointModal: AddUpdateCheckpointModalComponent;
  @ViewChild('checkpointDropdown') dropdown: any;

  public buildingId: number;
  public id: number;
  public isLoading: boolean;
  public isActionInProgress: boolean;
  public predefined: boolean;
  public root: TreeNode[];
  public options: any;
  public parentNode: ChecklistNode;
  public checkpoints: IdAndLabel[] = [];
  public readonly Localization = Localization;
  public readonly EditChecklistType = EditChecklistType;
  public allDropListsIds: number[];
  public allNodesExpanded = false;




  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private checklistsService: ChecklistsService,
    private translate: TranslateService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private dialogs: DialogService,
    private sessionStorageService: SessionStorageService,
    @Inject(DOCUMENT) private document: Document,
    private dialogService: MDBModalService,
    ) { }

  ngOnInit() {
    this.fetchCheckpoints();
    this.route.paramMap.subscribe(params => {
      this.buildingId = parseInt(this.route.parent.snapshot.params['bid'], 10);
      this.id = +params.get('id');
      this.loadDetails();
    });

    this.checklistsService.checklistUpdated$
      .subscribe((nodeId: number) => {
        if(this.id == nodeId){
          this.router.navigate(['../'], { relativeTo: this.route });
        }else{
          this.loadDetails();
        }
      });
  }

  public allowDrag(node: ITreeNode): boolean {
    return !this.predefined && node.data.id !== this.root[0].id;
  }

  private fetchCheckpoints(){
    this.checklistsService.getCheckpoints().subscribe(result => {
      this.checkpoints = result;
    })
  }

  public duplicateNode(node: ChecklistNode) {
    this.isActionInProgress = true;
    this.checklistsService.duplicateNode(node.id, node.parentId)
      .pipe(
        tap(() => this.isActionInProgress = false)
      )
      .subscribe(() => this.loadDetails());
  }

  public duplicateCheckpoint(checkpoint: any){
    this.isActionInProgress = true;
    this.checklistsService.duplicateNewCheckpoint(checkpoint)
      .pipe(
        tap(() => this.isActionInProgress = false)
      )
      .subscribe(() => this.loadDetails());

  }

  public onAddCustomCheckpoint($event: AddCustomCheckpointRequest) {
    this.addCustomCheckpointModal.show(this.buildingId, $event.parentNodeId, $event.label);
  }

  public onEditMandatoryClick(node: ChecklistNodeCheckpoint) {
      node.mandatory = !node.mandatory;
      this.checklistsService.updateChecklistNodeCheckpoint(node).subscribe();
  }

  public onEditButtonClick(node: any) {
    this.editNodeModal.show(node);
  }

  public onDeleteButtonClick(node: any) {
    if (node.hasOwnProperty('checkPoint')) {
      this.deleteNodeModal.show(node.id, Localization.AreYouSureYouWantToDelete, { value: node.checkPoint.label });
    } else {
      this.deleteNodeModal.show(node.id, Localization.AreYouSureYouWantToDelete, { value: node.label });
    }
  }

  public onChildOrCheckpointAdded() {
    this.loadDetails();
  }

  public deleteNodeOrCheckpoint(id: number){
    const isParentNode = id == this.parentNode.id;
    if (isParentNode || isChildNodeOf(this.parentNode.childNodes, id)) {
      this.deleteNodeGroup(id);
      return
    }
    this.deleteCheckpoint(id);
  }

  public deleteNodeGroup(id: number){
    this.isActionInProgress = true;
      this.checklistsService.deleteNode(id)
        .pipe(
          tap(() => this.isActionInProgress = false)
        ).subscribe();
  }

  public deleteCheckpoint(id: number) {
    this.isActionInProgress = true;
    this.checklistsService.deleteNodeCheckpoint(id)
      .pipe(
        tap(() => this.isActionInProgress = false)
      ).subscribe();
  }

  public onMove({ from, node, to }: any) {
    if (node.isBranch) {
      const localFromIndex = from.index - from.parent.payload.checkPoints.length;
      const localToIndex = to.index - to.parent.payload.checkPoints.length;
      if (from.parent.id === to.parent.id) {
        this.sortNodes(to.parent, localFromIndex, localToIndex);
      } else {
        this.transferNode(from.parent, to.parent, localFromIndex, localToIndex, node);
      }
    } else {
      if (from.parent.id === to.parent.id) {
        this.sortCheckpoints(to.parent, from.index, to.index);
      } else {
        this.transferCheckpoint(from.parent, to.parent, from.index, to.index, node);
      }
    }
  }


  moveSection(event: CdkDragDrop<string[]>): void {
    moveItemInArray(this.parentNode.childNodes, event.previousIndex, event.currentIndex);

  }

  reorderSections(event: CdkDragDrop<string>, parentNode: ChecklistNode){
    moveItemInArray(parentNode.childNodes, event.previousIndex, event.currentIndex);
    parentNode.childNodes.forEach((node, index) => node.index = index);
    this.isActionInProgress = true;
    this.checklistsService.sortNodes(parentNode.id, parentNode.childNodes.map(c => c.id))
      .pipe(
        tap(() => this.isActionInProgress = false)
      )
      .subscribe();
  }

  private confirmCustomisation() {
    return this.dialogs.confirm(ConfirmationDialogModel.create({
      title: '',
      text: this.translate.instant(Localization.CustomisePredefinedChecklistText),
      type: ConfirmDialogType.Warning,
      confirmText: Localization.Proceed,
    })).pipe(take(1)).toPromise();
  }

  public async editPredefinedChecklist() {
    if (await this.confirmCustomisation()) {
      this.customizePredefinedChecklist();
    }
  }

  public customizePredefinedChecklist() {
    this.isLoading = true;
    this.checklistsService.duplicateChecklist(this.parentNode.id, [this.buildingId])
      .pipe(finalize(() => this.isLoading = false))
      .subscribe();
  }

  public loadDetails() {
    this.isLoading = true;
    this.checklistsService.getChecklist(this.id)
      .pipe(
        tap(() => this.isLoading = false)
      )
      .subscribe(r => {
        this.parentNode = r;
        this.parentNode.type = this.parentNode.type ? this.parentNode.type : TemplateChecklistNodeType.CHECKUP
        this.predefined = r.businessId == null;
        this.parentNode.expanded = false;
        this.mapChildnodes(this.parentNode.childNodes);
        console.log('DROP LISTS', this.checkpointDroplistIds);
      });
  }

  private sortCheckpoints(parent: TreeNode, fromIndex: number, toIndex: number) {
    moveItemInArray(parent.payload.checkPoints, fromIndex, toIndex);
    parent.payload.checkPoints.forEach((node, index) => node.index = index);
    this.isActionInProgress = true;
    this.checklistsService.sortCheckpoints(parent.payload.id, parent.payload.checkPoints.map(c => c.id))
      .pipe(
        tap(() => this.isActionInProgress = false)
      )
      .subscribe();
  }

  private sortNodes(parent: TreeNode, fromIndex: number, toIndex: number) {
    moveItemInArray(parent.payload.childNodes, fromIndex, toIndex);
    parent.payload.childNodes.forEach((node, index) => node.index = index);
    this.isActionInProgress = true;
    this.checklistsService.sortNodes(parent.payload.id, parent.payload.childNodes.map(c => c.id))
      .pipe(
        tap(() => this.isActionInProgress = false)
      )
      .subscribe();
  }

  private transferCheckpoint(from: TreeNode, to: TreeNode, fromIndex: number, toIndex: number, item: TreeNode) {
    transferArrayItem(from.payload.checkPoints, to.payload.checkPoints, fromIndex, toIndex);
    from.payload.checkPoints.forEach((node, index) => node.index = index);
    to.payload.checkPoints.forEach((node, index) => node.index = index);
    item.payload.templateChecklistNodeId = to.payload.id;
    this.isActionInProgress = true;
    this.checklistsService.updateChecklistNodeCheckpoint(item.payload).subscribe(() => {
      forkJoin([
        this.checklistsService.sortCheckpoints(from.payload.id, from.payload.checkPoints.map(c => c.id)),
        this.checklistsService.sortCheckpoints(to.payload.id, to.payload.checkPoints.map(c => c.id)),
      ])
        .pipe(
          tap(() => this.isActionInProgress = false)
        )
        .subscribe();
    });
  }

  private transferNode(from: TreeNode, to: TreeNode, fromIndex: number, toIndex: number, item: TreeNode) {
    transferArrayItem(from.payload.childNodes, to.payload.childNodes, fromIndex, toIndex);
    from.payload.childNodes.forEach((node, index) => node.index = index);
    to.payload.childNodes.forEach((node, index) => node.index = index);
    item.payload.parentId = to.payload.id;
    this.isActionInProgress = true;
    this.checklistsService.updateNode(item.payload, false).subscribe(() => {
      forkJoin([
        this.checklistsService.sortNodes(from.payload.id, from.payload.childNodes.map(c => c.id)),
        this.checklistsService.sortNodes(to.payload.id, to.payload.childNodes.map(c => c.id)),
      ])
        .pipe(
          tap(() => this.isActionInProgress = false)
        )
        .subscribe();
    });
  }

  public mapChildnodes(nodes: ChecklistNode[]) {
    nodes.map(e => {
      if(e.childNodes.length || e.checkPoints.length){
        e.hasChild = true;
        e.expanded = this.sessionStorageService.getNodeExpandedStatus(e.id) != null ? this.sessionStorageService.getNodeExpandedStatus(e.id) : true;
        this.mapChildnodes(e.childNodes);
      }else{
        e.hasChild = false;
      }
    });
  }

  public mapCheckpoints(node: ChecklistNode, list: ChecklistNodeCheckpoint[] = []): ChecklistNodeCheckpoint[]{
    node.checkPoints?.forEach(e => list.push(e));
    node.childNodes.map(e => {
      if(e.checkPoints.length || e.childNodes.length){
        e.checkPoints?.forEach(e => list.push(e));
        this.mapCheckpoints(e, list)
      }
    })
    return list
  }

  public async renameChecklist() {
    const data = {node: this.parentNode}
    const ref = this.dialogService.show(RenameChecklistModal, {data, class: 'modal-dialog-centered'});
    const dialog = ref.content as RenameChecklistModal;
    this.parentNode = await dialog.onNodeUpdated;
  }

  public onDelete(id: number, label: string){
    this.deleteNodeModal.show(id, Localization.AreYouSureYouWantToDelete, { value: label });
  }

  public async onCopyChecklist() {
    const data = {checklistId: this.parentNode.id, buildingId: this.buildingId};
    const ref = this.dialogService.show(CopyChecklistModalComponent, {data, class: 'modal-dialog-centered'});
    const dialog = ref.content as CopyChecklistModalComponent;
    await dialog.onCreated;

  }

  public onChecklistDuplicated(amountCopied: number){
    let message = amountCopied == 1 ? this.translate.instant(this.Localization.ChecklistHasBeenCopied) : this.translate.instant(this.Localization.ChecklistHasBeenCopiedMultiple, {amount: amountCopied})
    this.snackBar.open(message, null, {
      duration: 3000
    })
  }

  public addOrUpdateNode(node: ChecklistNode, isSection: boolean, isUpdate: boolean){
    this.addUpdateNodeModal.show(node, isSection, isUpdate);
  }

  public addOrUpdateCheckpoint(node: any, isUpdate: boolean = false){
    isUpdate ? this.addUpdateCheckpointModal.show(node.templateChecklistNodeId, node.checkPoint)
    : this.openAddCheckpointModal(this.translate.instant(Localization.AddCheckpoint), this.getAddCheckpointTypes(), node);
  }

  public onAddCheckpointTypeSelected(result: AddCheckpointDialogResult){
    this.addCheckpointOptionsModal.close();
    if(Object.values(AddCheckpointType).includes(result.value)){
      switch(result.value){
        case AddCheckpointType.NEW:
          this.addUpdateCheckpointModal.show(result.node.id);
          break;
        case AddCheckpointType.PREVIOUSLY:
          const list = this.mapCheckpoints(this.parentNode).map(ck => new IdAndLabel(ck.id, ck.checkPoint.label));
          this.openAddCheckpointModal(this.translate.instant(Localization.YourPreviouslyAddedCheckpoints), list, result.node);
          break;
        case AddCheckpointType.PREDEFINED:
          let nodeCheckpointIds = result.node.checkPoints.map(c => c.templateCheckPointId);
          this.openAddCheckpointModal(this.translate.instant(Localization.PredefinedCheckpoints), this.checkpoints.filter(c => !nodeCheckpointIds.includes(c.id)).sort((c1, c2) => c1.label > c2.label ? 1 : (c1.label < c2.label ? -1 : 0)), result.node);
          break;
        default:
          break;
        }
    }else{
      this.isActionInProgress = true;
      var checklistNodeCheckpoint = this.mapCheckpoints(this.parentNode, []).find(node => node.id == result.value)?.checkPoint;
      if(checklistNodeCheckpoint){
        let duplicate: TemplateCheckpoint = {
          ...checklistNodeCheckpoint,
          reference: checklistNodeCheckpoint.label,
        }
        duplicate.id = null;
        this.checklistsService.addNewCheckpoint(duplicate)
        .pipe(
          tap(() => this.isActionInProgress = false),
          filter(templateCheckpoint => templateCheckpoint.id !== undefined),
          flatMap(templateCheckpoint => this.checklistsService.addCheckpoint(result.node.id, templateCheckpoint.id))
        ).subscribe(() => {
          this.addCheckpointOptionsModal.close();
        });
      }else{
        this.checklistsService.addCheckpoint(result.node.id, result.value)
        .pipe(
          tap(() => this.isActionInProgress = false)
        )
        .subscribe(() => {
          this.addCheckpointOptionsModal.close();
        })
      }

    }
  }

  private openAddCheckpointModal(title: string, items: IdAndLabel[], node: ChecklistNode){
    // this.addCheckpointOptionsModal.show({title, items, node} as SelectModalViewModel);
  }

  private getAddCheckpointTypes(): IdAndLabel[]{
    return Object.keys(AddCheckpointType).map(type => new IdAndLabel(AddCheckpointType[type], this.translate.instant(`addCheckpointType_${AddCheckpointType[type]}`)));
  }

  public isNodeChild(node: ChecklistNode): boolean{
    return node.parentId != this.parentNode.id;
  }

  public toggleNodeExpansion(node: ChecklistNode){
    node.expanded = !node.expanded
    this.sessionStorageService.setNodeExpandedStatus(node);
  }



  public toggleDropdowns(event: PointerEvent){
    const substring = "open show";
    this.document.querySelectorAll('.dropdowns').forEach(el => {
      if(el.className.includes(substring)){
        el.className = el.className.replace(substring, '');
      }
    });
    event.stopPropagation();
  }

  public duplicateNodeMultipleTimes(original: ChecklistNode) {
   const data: DuplicateMultipleTimesData = { original };
    const dialog = this.dialog.open(DuplicateMultipleTimesModalComponent, { panelClass: 'full-bleed', data,  });
    dialog.afterClosed().pipe(
      take(1), filter(Boolean)
    ).subscribe(() => this.loadDetails())
  }

  public moveCheckpoint(checkpointMove: CdkDragDrop<any, any>) {

  }

  public get checkpointDroplistIds(): number[] {
    return this.checklistNodeIdsFor(this.parentNode);
  }

  private checklistNodeIdsFor(node: ChecklistNode): number[] {
    const childNodeIds =  node?.childNodes.reduce((all, child) => ([
        ...all,
        child.id,
        ...this.checklistNodeIdsFor(child),
    ]), []) || [];
    if (node && !node?.parentId) {
      childNodeIds.unshift(node.id);
    }
    return childNodeIds;
  }

  public expandAll() {
    this.allNodesExpanded = !this.allNodesExpanded;
    const nodes = flattenChecklistNode(this.parentNode);
    nodes.forEach(node => node.expanded = this.allNodesExpanded);
  }

  public async addNewGroup($event: MouseEvent) {
    const createdNode = await this.presentNodeDialog();
    if (createdNode) {
      this.parentNode.childNodes = [
        ...this.parentNode.childNodes,
        createdNode,
      ];
    }
  }



  public async addNewCheckpoint($event: MouseEvent) {
    const selectedMethod = await this.selectCreationMethod();

    switch (selectedMethod) {
      case AddCheckpointType.NEW:
        await this.createNewCheckpoint();
        break;
      default:
        await this.copyExistingCheckpoint(selectedMethod);
    }


  }

  private async selectCreationMethod() {
    const ref = this.dialogService.show(SelectCheckpointCreationMethodModal, {class: 'modal-dialog-centered'})
    const createDialog = ref.content as SelectCheckpointCreationMethodModal;
    return await createDialog.selection;
  }

  private async presentNodeDialog() {
    const ref = this.dialogService.show(AddUpdateNodeModalComponent, {class: 'modal-dialog-centered'})
    const createDialog = ref.content as AddUpdateNodeModalComponent;
    return await createDialog.createFor(this.parentNode, true);
  }

  private async createNewCheckpoint() {
    const ref = this.dialogService.show(AddUpdateCheckpointModalComponent, {class: 'modal-dialog-centered'})
    const createDialog = ref.content as AddUpdateCheckpointModalComponent;
    await createDialog.show(this.parentNode.id);
  }


  private allCheckpointsIn(node: ChecklistNode) {
    const checkpoints = flattenChecklistNode(node)
                  .reduce((checkpoints, node) => ([
                      ...checkpoints,
                      ...node.checkPoints,
                  ]), [] as ChecklistNodeCheckpoint[]);
    return Promise.resolve(checkpoints);
  }

  private get predefinedCheckpoints() {
    return this.checklistsService.predefinedCheckpoints(this.buildingId);
  }

  private async copyExistingCheckpoint(checkpointType: AddCheckpointType.PREVIOUSLY | AddCheckpointType.PREDEFINED) {
    const checkpoints = checkpointType === AddCheckpointType.PREDEFINED ?
        this.predefinedCheckpoints : this.allCheckpointsIn(this.parentNode);

    const data: SelectExistingCheckpointData = {
      title: Localization.YourPreviouslyAddedCheckpoints,
      checkpoints$: checkpoints,
    }

    const ref = this.dialogService.show(SelectExistingCheckpointModalComponent, {data, class: 'modal-dialog-centered'});
    const selectDialog = ref.content as SelectExistingCheckpointModalComponent;
    const selection = await selectDialog.selection;
    if (selection) {
      this.isActionInProgress = true;
      const checkpointToDuplicate = selection.checkPoint;
      let duplicate = {
        ...checkpointToDuplicate,
        reference: checkpointToDuplicate.label,
        id: null,
      } as TemplateCheckpoint;

      duplicate = await this.checklistsService.addNewCheckpoint(duplicate).toPromise();
      await this.checklistsService.addCheckpoint(this.parentNode.id, duplicate.id).toPromise();

      this.isActionInProgress = false;
    }

  }

  public async changeChecklistType() {
    const data = {node: this.parentNode };
    const ref = this.dialogService.show(ChangeChecklistTypeModal, {data, class: 'modal-dialog-centered'});
    const dialog = ref.content as ChangeChecklistTypeModal;
    this.parentNode = await dialog.onNodeUpdated;
  }

  public async deleteChecklist() {
    if (await this.confirmDeletingChecklist()) {
      this.isLoading = true;
      try {
        await this.checklistsService.deleteNode(this.parentNode.id).toPromise();

      } finally {
        this.isLoading = false;
      }
    }
  }

  private async confirmDeletingChecklist() {
    return this.dialogs.confirm(ConfirmationDialogModel.create({
      title: 'Confirm delete',
      text: this.translate.instant(Localization.AreYouSureYouWantToDelete, { value: this.parentNode.label}),
      confirmText: Localization.DeleteChecklist,
    })).pipe(take(1)).toPromise();
  }
}

export function flattenChecklistNode(node: ChecklistNode): ChecklistNode[] {
  let flattenedNodes: ChecklistNode[] = [];

  // Add the current node to the flattened array
  flattenedNodes.push(node);

  // Recursively flatten child nodes and concatenate them to the flattened array
  if (node.childNodes.length > 0) {
    for (const childNode of node.childNodes) {
      flattenedNodes = flattenedNodes.concat(flattenChecklistNode(childNode));
    }
  }

  return flattenedNodes;
}
